export interface CustomDataOperator {
  id: number;
  value: string;
}
